import React from 'react';

const JScolored = ({ className = '' }) => {
  return (
    <svg className={className} width="57" height="57" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#F7DF1E" d="M.86 0h54v54h-54z" />
        <path
          d="M37.3820463 42.5322433c1.1003156 1.7978757 2.5318529 3.1193838 5.0637058 3.1193838 2.1269299 0 3.4856331-1.063801 3.4856331-2.5336859 0-1.7614323-1.3959874-2.385309-3.7370842-3.4100635l-1.2832679-.5509899c-3.7041355-1.5792152-6.1648884-3.5575727-6.1648884-7.7398898 0-3.8525909 2.9333076-6.7854191 7.5175221-6.7854191 3.2636624 0 5.6099617 1.1366879 7.3007539 4.1129011l-3.9972061 2.5683939c-.880079-1.5792151-1.8295239-2.2013565-3.3035478-2.2013565-1.5035044 0-2.4564175.9544707-2.4564175 2.2013565 0 1.5410364.9537802 2.1649131 3.1561453 3.1193839l1.2832679.5501222c4.3613768 1.8716303 6.8238638 3.779704 6.8238638 8.069616 0 4.6248444-3.6304342 7.1585303-8.5059852 7.1585303-4.7671668 0-7.8470098-2.2733757-9.3539825-5.2530597l4.1714877-2.4252233zm-18.1330956.4451304c.8063778 1.4317061 1.5399214 2.6421485 3.3035477 2.6421485 1.6864568 0 2.7503553-.6603202 2.7503553-3.2278464v-17.466814h5.1330716v17.53623c0 5.319005-3.11626 7.7398898-7.6649245 7.7398898-4.1099256 0-6.4900407-2.1284697-7.7004745-4.6920912l4.1784244-2.5315167z"
          fill="#000"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};
export default JScolored;
